import React from 'react';
import { Invoice } from '../../types';
import { openAmountCents } from '../../services/invoiceLogic';
import { formatCents } from '../../services/money';

/**
 * Suchfeld mit Trefferliste fuer eine offene Rechnung — im Kontoauszugsimport
 * je Zeile und je Teil einer Aufteilung. Welche Rechnungen in Frage kommen,
 * entscheidet der Aufrufer (results).
 */

interface Props {
    text: string;
    onText: (text: string) => void;
    results: Invoice[];
    onPick: (invoiceId: string) => void;
    onClose: () => void;
    customerNameOf: (invoice: Invoice) => string;
}

export const InvoiceSearchPopover: React.FC<Props> = ({
    text,
    onText,
    results,
    onPick,
    onClose,
    customerNameOf,
}) => (
    <div className="mt-1 w-full max-w-[20rem] rounded border border-slate-300 bg-white p-1.5 shadow-sm">
        <input
            autoFocus
            value={text}
            onChange={(e) => onText(e.target.value)}
            onKeyDown={(e) => {
                if (e.key === 'Escape') onClose();
            }}
            placeholder="Nummer, Kunde oder Betrag"
            className="w-full rounded border border-slate-300 px-1.5 py-1 text-slate-700"
        />
        <ul className="mt-1 max-h-48 overflow-auto">
            {results.map((option) => {
                const name = customerNameOf(option);
                return (
                    <li key={option.id}>
                        <button
                            type="button"
                            onClick={() => onPick(option.id)}
                            className="block w-full rounded px-1.5 py-1 text-left text-slate-700 hover:bg-slate-100"
                        >
                            <span className="font-medium">{option.invoiceNumber ?? 'ohne Nummer'}</span>
                            {' · offen '}
                            {formatCents(openAmountCents(option))}
                            {name && <span className="block truncate text-[11px] text-slate-500">{name}</span>}
                        </button>
                    </li>
                );
            })}
            {results.length === 0 && (
                <li className="px-1.5 py-1 text-slate-400">Keine offene Rechnung gefunden.</li>
            )}
        </ul>
        <button type="button" onClick={onClose} className="mt-1 text-[11px] text-slate-500 hover:underline">
            Abbrechen
        </button>
    </div>
);
